"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = (0, _immutable.Record)({
  accountName: null,
  accountType: null,
  domain: null,
  id: 0,
  numberOfUsers: 0,
  numberOfContacts: 0,
  obscured: false,
  products: (0, _immutable.List)(),
  cookieWeight: 0,
  disabled: false
}, 'Account');

exports.default = _default;
module.exports = exports.default;